module.exports = __webpack_public_path__ + "static/media/menu-outline.a8754715.svg";